import React from 'react';
import { useSelector } from 'react-redux';
import { Visibility } from '@material-ui/icons';
import NotificationsIcon from '@material-ui/icons/Notifications';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import moment from 'moment';

import { useWindowSize } from '../../../../../../../../common/functions/utils';

import styles from './TableComponents.module.css';


export const TNotificationInfo = (props) => {

    const { width } = useWindowSize();

    const setting = useSelector(({ generalSetting }) => generalSetting && generalSetting.setting);
    const dateTimeFormatted = moment(props.row['createdAt']).format('DD MMM YYYY hh:mm a');

    return (
        <div 
            className={styles.notificationInfoContainer}
            onClick={() => {
                if (width < 460) {
                    props.handleView(props.row);
                };
            }}
        >
            <div className={styles.notificationsIconContainer}>
                {props.row['status'] === 'New' ?
                    <div className='pb-3'>
                        <NotificationsActiveIcon className={styles.notificationsIcon} />
                        <p className={styles.notificationsText}>New!</p>
                    </div>
                    :
                    <NotificationsIcon className={styles.notificationsIcon} />
                }
            </div>
            <div className={`${styles.notificationInfo} ml-3 ml-lg-5 col-10`}>
                <p className='m-0 p-0 col-12 col-lg-6'>
                    {props.row['message']}
                </p>
                <p className='m-0 p-0 pl-xl-4 col-10 col-lg-6'>
                    {dateTimeFormatted}
                </p>
            </div>
        </div>
    );
};


export const TActionButtons = (props) => {

    return (
        <div className={styles.actionButtons}>
            <Visibility
                className={styles.viewIcon}
                onClick={() => props.handleView(props.row)}
            />
            <i
                className={`${styles.deleteIcon} fa fa-trash`}
                onClick={() => props.handleDelete(props.row)}
            />
        </div>
    );
};